function handleAlignUpdate(value, objId, componentDimensions, setComponentDimensions, activeDisplay) {
    let newObjs = [ ...componentDimensions ];
    let left;
    let center_v;
    let center_w;
    let height;
    let top; 
    let bottom;
    let obj = newObjs.find(a => a.id === objId);
    let activeDisplay_width_px = activeDisplay.width_px;
    let activeDisplay_height_px = activeDisplay.height_px; 
    
    switch (value) {
      case "right":
        obj.x_pos = activeDisplay_width_px - obj.width
        setComponentDimensions(newObjs)
        // console.log('right', right)
        break;
      case "left":

        function setLeft(){
          obj.x_pos = 0
          setComponentDimensions(newObjs)
        }
        setLeft()
        break;
      case "center_w":
        obj.x_pos = activeDisplay_width_px/2 - obj.width/2
        setComponentDimensions(newObjs)
          break;
      
      case "top":
        obj.y_pos = 0
        setComponentDimensions(newObjs)
        
          break;
      case "center_v":
          obj.y_pos = activeDisplay_height_px/2 - obj.height/2
          setComponentDimensions(newObjs)
          break;

      case "bottom":
          obj.y_pos = activeDisplay_height_px - obj.height
          setComponentDimensions(newObjs)

          break;
      default:
        break;
    }
  }

  export default handleAlignUpdate;